import { StyleSheet } from 'react-native';
import { colors, dimensions } from '../../../../styles';

export default StyleSheet.create({
  contentContainer: {
    backgroundColor: colors.grayLightest,
  },
});
